import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LandingPage from '../components/landingPage';
import * as LandingPageAction from '../actions/landingPageAction';
import * as bankAction from '../actions/bankAction';

function mapStateToProps(state) {
  const {
    wallet_limit,
    userInfo = {},
    productList = [],
    isAdminView = false,
    ONBOARD,
    activatestatus = {},
    productListAPICall = false,
    tutorialFlagResponse = {}
  } = state.Chargecard;
  return {
    org_limit: wallet_limit?.org_limit || {},
    user_limit: wallet_limit?.user_limit || {},
    userInfo,
    productList,
    isAdminView,
    onboard: ONBOARD || {},
    activatestatus,
    productListAPICall,
    tutorialFlagResponse
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...LandingPageAction,
      ...bankAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
